import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box } from '@utex/ui-kit';

import { Hint } from '../../../../../Hint';
import { EmailLink } from './components/EmailLink';
import { TelegramLink } from './components/TelegramLink';

interface Props {
  expirationDate?: string | null;
}

export const SoftBlockHint: React.FC<Props> = ({ expirationDate }) => {
  const { i18n } = useTranslation('withdraw');
  const currentLang = i18n.language;

  const localizedExpirationDate =
    expirationDate &&
    new Date(expirationDate).toLocaleString(currentLang, {
      day: 'numeric',
      month: 'long',
      hour: 'numeric',
      minute: 'numeric',
    });

  return (
    <Box>
      <Hint withMargin={false}>
        {localizedExpirationDate ? (
          <Trans i18nKey="withdraw:Money withdrawal is blocked until">
            Money withdrawal is blocked until
            {{ expirationDate: localizedExpirationDate }}
            to protect the account. If you need to withdraw urgently – contact us via
            <EmailLink>E-mail</EmailLink>
            or
            <TelegramLink>Telegram</TelegramLink>
          </Trans>
        ) : (
          <Trans i18nKey="withdraw:Money withdrawal is blocked to protect the account">
            Money withdrawal is blocked to protect the account
            <EmailLink>E-mail</EmailLink>
            or
            <TelegramLink>Telegram</TelegramLink>
          </Trans>
        )}
      </Hint>
    </Box>
  );
};
